import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { requestLogin } from '../api/login';
import { seoDefaults } from "../utils/seoDefaults";
import SEO from "../api/seo";
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await requestLogin(formData.email, formData.password);
      login(res.token, res.user);
      navigate('/user-profile', { state: { user: res.data } });
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = () => {
    if (!formData.email) {
      setError('Please enter your email to reset password');
      return;
    }
    navigate('/forgot-password', { state: { email: formData.email } });
  };

  return (
    <>
     <SEO {...seoDefaults.login} />
    <div className="min-h-screen flex items-center justify-center bg-gray-950 text-white relative overflow-hidden">
      <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-purple-900/20 rounded-full filter blur-3xl animate-pulse"></div>
      <div className="absolute top-1/2 right-1/4 w-96 h-96 bg-cyan-900/20 rounded-full filter blur-3xl animate-pulse"></div>

      <div className="relative z-10 w-full max-w-sm p-8 rounded-2xl bg-gradient-to-br from-gray-900 to-gray-800 shadow-lg border border-gray-700/60">
        <h2 className="text-3xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500">
          Gamer Login
        </h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm mb-1 text-gray-300">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500"
              placeholder="gamer@example.com"
              required
            />
          </div>
          <div>
            <label className="block text-sm mb-1 text-gray-300">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="********"
              required
            />
          </div>

          {error && <p className="text-red-400 text-sm">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-lg bg-gradient-to-r from-cyan-500 to-purple-600 text-white font-semibold tracking-wide hover:shadow-lg hover:shadow-cyan-500/30 transition-all"
          >
            {loading ? "Logging in..." : "LOGIN"}
          </button>
        </form>

        <p className="mt-4 text-center text-sm">
          <button
            type="button"
            onClick={handleForgotPassword}
            className="text-purple-400 hover:underline"
          >
            Forgot Password?
          </button>
        </p>

        <p className="mt-3 text-center text-sm text-gray-400">
          Don’t have an account?{' '}
          <Link to="/signup" className="text-cyan-400 hover:underline">
            Sign up
          </Link>
        </p>
      </div>
    </div>
    </>
  );
};

export default Login;
